import { render } from "./MediaControls.vue?vue&type=template&id=2bf52854&scoped=true"
import script from "./MediaControls.vue?vue&type=script&lang=js"
export * from "./MediaControls.vue?vue&type=script&lang=js"

import "./MediaControls.vue?vue&type=style&index=0&id=2bf52854&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bf52854"

export default script